export default class wcQuantity {

    constructor() {

    }

    init() {
        const pQuantity = document.querySelectorAll('.wooMain  .quantity, .product-quantity .quantity');

        if (pQuantity && pQuantity.length > 0) {
            [...pQuantity].forEach((pq) => {
                const pQinput = pq.querySelector(':scope .qty:not([type="hidden"])');
                if (pQinput) {
                    const pQUp = document.createElement('span');
                    pQUp.classList.add('quanyityUp');
                    const pQDown = document.createElement('span');
                    pQDown.classList.add('quanyityDown');
                    pq.appendChild(pQUp);
                    pq.appendChild(pQDown);


                    const quentityChange = (dir) => {
                        let newVal = pQinput.value;
                        dir == 'down' ? newVal-- : newVal++;
                        if (newVal <= 0) newVal = 1;
                        pQinput.value = newVal;
                        const e = new Event("change", { bubbles: true });
                        pQinput.dispatchEvent(e);
                    }
                    pQUp.addEventListener('click', () => quentityChange('up'));
                    pQDown.addEventListener('click', () => quentityChange('down'));
                    pQinput.addEventListener('change', () => {
                        if (pQinput.value <= 0) pQinput.value = 1;
                    });
                }

            });


        }
    }
}